module.exports = __webpack_public_path__ + "iconV.db31f632.png";